module.exports = __webpack_public_path__ + "img/studio_transparency.aa3630df.png";